import React, { ReactElement } from 'react'
import { StudyMaterialsGuideExternalLinkProps } from '@/components/static/StudyMaterialsGuidePage/GuideComponents/StudyMaterialsGuideExternalLink/StudyMaterialsGuideExternalLink.types'
import { reusableCssClass } from '@/utils/reusableCssClasses'

export const StudyMaterialsGuideExternalLink: React.FC<
    StudyMaterialsGuideExternalLinkProps
> = (props): ReactElement => {
    return (
        <a
            className={reusableCssClass.clickableText}
            href={props.href}
            target={'_blank'}
            rel={'noopener noreferrer'}
        >
            {props.text}
        </a>
    )
}
